import { Routes, Route, useLocation } from "react-router-dom";
import Home from "./Pages/Home";
import HeaderNav from "./Components/Header";
import Footer from "./Components/Footer";
import Galary from "./Pages/Galary";
import Events from "./Pages/Events";
import About from "./Components/About";
import Contact from "./Pages/Contact";
import Certification from "./Pages/Certificate";
import Media from "./Pages/Media";
import AnnualReport from "./Pages/Annual";
import AppAnnual from "./Pages/AppAnnual";
import WhyDonation from "./Components/Donate";
import Provision from "./Pages/80g_12a";
import Termsandcondition from "./Components/Termsandcondition";
import PrivacyandPolicy from "./Components/PrivacyandPolicy";
import Receipt from "./Receipt";
import ProvisionalReceipt from "./ProvisionalReceipt";
import Navbar from "./Components/Navbar";
import SewingMachineForm from "./Components/form/SewingMachineForm";
import HealthCampForm from "./Components/form/HealthCampForm";
import FarmerForm from "./Components/form/FarmerForm";
import CataractCampForm from "./Components/form/CataractCampForm";
import TricycleForm from "./Components/form/TricycleForm";
import RunningCompetitionForm from "./Components/form/RunningCompetitionForm";

function App() {
    const location = useLocation();
    const routesWithoutHeaderFooter = ["/annualreport"];
    const shouldHideHeaderFooter = () => {
        return routesWithoutHeaderFooter.includes(location.pathname);
    };

    return (
        <>
            {!shouldHideHeaderFooter() &&
                (
                    <>
                        <HeaderNav />
                        <Navbar />
                    </>
                )
            }
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/certificate" element={<Certification />} />
                <Route path="/gallery" element={<Galary />} />
                <Route path="/event" element={<Events />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/media" element={<Media />} />
                <Route path="/annual" element={<AnnualReport />} />
                <Route path="/annualreport" element={<AppAnnual />} />
                <Route path="/whydonation" element={<WhyDonation />} />
                <Route path="/provision" element={<Provision />} />
                <Route path="/terms" element={<Termsandcondition />} />
                <Route path="/privacy" element={<PrivacyandPolicy />} />
                <Route path="/receipt" element={<Receipt />} />
                <Route path="/receipts" element={<ProvisionalReceipt />} />
                <Route path="/sewing-machine-form" element={<SewingMachineForm/>} />
                <Route path="/farmer-form" element={<FarmerForm/>} />
                <Route path="/tricycle-form" element={<TricycleForm/>} />
                <Route path="/cataract-camp-form" element={<CataractCampForm/>} />
                <Route path="/health-camp-form" element={<HealthCampForm />} />
                <Route path="/running-competition-form" element={<RunningCompetitionForm />} />
            </Routes>
            {!shouldHideHeaderFooter() && <Footer />}
        </>
    );
}

export default App;
